import { UserEligibilityKeys } from 'constants/user-eligibility';
import { IMultiChoiceButtonOption } from '@ruby-labs/ui-core-kit';

export const isUserStatusNeedsReview = (pageValue: IMultiChoiceButtonOption[], userStatus: string) =>
    pageValue?.length > 0 &&
    pageValue[0].value !== 'none' &&
    userStatus === UserEligibilityKeys.userStatus.approved;
